import { Loader2, Inbox } from "lucide-react";
import { EMP_STATUS, REQ_STATUS_CLS, COMP_STATUS_CLS, SLA } from "../lib/format";

export const DemoBadge = ({ className = "" }) => (
  <span data-testid="demo-badge" className={`inline-flex items-center bg-amber-100 text-amber-800 border border-amber-300 px-2.5 py-0.5 rounded-full text-[10px] font-bold tracking-wider uppercase ${className}`}>
    Demonstração
  </span>
);

export const PendingIntegration = ({ label = "Integração pendente" }) => (
  <span data-testid="pending-integration-badge" className="inline-flex items-center bg-slate-100 text-slate-600 border border-slate-300 px-2 py-0.5 rounded-full text-[10px] font-semibold tracking-wide uppercase">
    {label}
  </span>
);

export const Pill = ({ cls, children, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center whitespace-nowrap border px-2 py-0.5 rounded-full text-[11px] font-medium ${cls}`}>{children}</span>
);

export const EmpStatus = ({ s }) => <Pill cls={EMP_STATUS[s]?.cls}>{EMP_STATUS[s]?.label || s}</Pill>;
export const ReqStatus = ({ s, label }) => <Pill cls={REQ_STATUS_CLS[s]}>{label || s}</Pill>;
export const CompStatus = ({ s, label }) => <Pill cls={COMP_STATUS_CLS[s]}>{label || s}</Pill>;
export const SlaPill = ({ s }) => (s ? <Pill cls={SLA[s]?.cls}>{SLA[s]?.label}</Pill> : null);

export const PageHeader = ({ title, subtitle, actions, eyebrow, demo }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 fade-up">
    <div>
      {eyebrow && <div className="label-xs mb-2 flex items-center gap-2">{eyebrow}{demo && <DemoBadge />}</div>}
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1.5 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const Card = ({ children, className = "", testid, hover }) => (
  <div data-testid={testid} className={`card-surface ${hover ? "card-hover" : ""} ${className}`}>{children}</div>
);

export const CardHead = ({ title, hint, right }) => (
  <div className="flex items-start justify-between gap-3 px-5 pt-5 pb-3">
    <div>
      <h3 className="text-[15px] font-semibold text-slate-900">{title}</h3>
      {hint && <p className="text-xs text-slate-500 mt-0.5">{hint}</p>}
    </div>
    {right}
  </div>
);

export const Loading = ({ label = "Carregando..." }) => (
  <div data-testid="loading-state" className="flex items-center gap-2 text-sm text-slate-500 py-16 justify-center">
    <Loader2 className="h-4 w-4 animate-spin" /> {label}
  </div>
);

export const Empty = ({ title = "Nada por aqui ainda", hint }) => (
  <div data-testid="empty-state" className="flex flex-col items-center justify-center text-center py-12 px-4">
    <div className="h-10 w-10 rounded-full bg-slate-100 flex items-center justify-center mb-3"><Inbox className="h-5 w-5 text-slate-400" /></div>
    <p className="text-sm font-medium text-slate-700">{title}</p>
    {hint && <p className="text-xs text-slate-500 mt-1 max-w-sm">{hint}</p>}
  </div>
);

export const Field = ({ label, value, mono, testid }) => (
  <div>
    <div className="label-xs">{label}</div>
    <div data-testid={testid} className={`text-sm text-slate-900 mt-1 ${mono ? "font-mono text-[13px]" : ""}`}>{value ?? "—"}</div>
  </div>
);

export const InsightRow = ({ i }) => {
  const map = {
    atencao: ["ATENÇÃO", "border-amber-400 bg-amber-50/60", "text-amber-800"],
    positivo: ["POSITIVO", "border-emerald-500 bg-emerald-50/60", "text-emerald-700"],
    informacao: ["INFORMAÇÃO", "border-sky-500 bg-sky-50/60", "text-sky-700"],
    critico: ["CRÍTICO", "border-rose-500 bg-rose-50/60", "text-rose-700"],
  }[i.level] || ["INFO", "border-slate-300 bg-slate-50", "text-slate-600"];
  return (
    <div data-testid={`insight-${i.id}`} className={`border-l-4 rounded-r-lg px-4 py-3 ${map[1]}`}>
      <div className={`text-[10px] font-bold tracking-widest ${map[2]}`}>{map[0]}</div>
      <div className="text-sm font-medium text-slate-900 mt-0.5">{i.title}</div>
      <div className="mt-2 grid sm:grid-cols-2 gap-2 text-xs">
        <div><span className="font-semibold text-slate-600">Dado: </span><span className="text-slate-600">{i.data}</span></div>
        <div><span className="font-semibold text-slate-600">Interpretação: </span><span className="text-slate-600">{i.interpretation}</span></div>
      </div>
    </div>
  );
};
